var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loan-detail-container"},[_c('HeaderCard'),_c('SubjectInfoCard',{attrs:{"subjectInfo":_vm.subjectInfo}}),_c('BusinessInfoCard',{attrs:{"businessInfo":_vm.businessInfo}}),(_vm.isShowLoanInfoCard)?_c('LoanInfoCard',{attrs:{"loanInfo":_vm.loanInfo}}):_vm._e(),_c('FooterCard',{attrs:{"subjectInfo":_vm.subjectInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }